/** 1=Direct, 2=Lob, 3=Skip. Not in NSwag `api.ts` — that file is overwritten on every API build. */
export enum ShotTechniqueEnum {
    Direct = 1,
    Lob = 2,
    Skip = 3,
}
